export const getUseableFontFamily = (name: string | undefined) => {
  if (!name) return '';

  return `"${name}"`;
};
